export { default } from "./TagPromotional";
